module.exports = __webpack_public_path__ + "images/emoji/hibiscus.f25796c5501d65adf217.png";